import 'react-nice-select-tsx/nice-select.css';
import './../sass/style.scss';
import './../css/responsive.css';
import 'react-range-slider-input/dist/style.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import './../css/fontawesome-solid-free.min.css';
import './../css/fontawesome-brands.min.css';
import './../css/font-icons.css';
import { Layout } from './pages';
import { AppRoutes } from './AppRoutes.tsx';
import { InitialScrollToTop } from '@utils';

const App = () => (
  <Layout>
    <AppRoutes />
    <InitialScrollToTop />
  </Layout>
);

export default App;
